import React, { Component } from 'react'
import { connect } from 'react-redux';

import AsSwitch from './airship-wrappers/AsSwitch'
import { withCarto } from '../carto/withCarto';

class DpsLayerToggle extends Component {
  state = {
    checked: false,
  }

  componentDidMount() {
    let checked = this.props.checked || false
    this.setState(state => ({
      ...state,
      checked: checked
    }))
  }

  onChanged = (event) => {
    this.toggle(event.detail)
    this.setState(state => ({...state, checked: event.detail}))
  }

  toggle(value) {
    if (value) this.props.CartoContext.layers[this.props.layer].show()
    else this.props.CartoContext.layers[this.props.layer].hide()
  }

  render() {
    return (
      <div style={{marginTop: 8, marginBottom: 8}}>
        <AsSwitch label={this.props.label} onChanged={this.onChanged} checked={this.state.checked}></AsSwitch>
        <div style={{display: this.state.checked ? 'block' : 'none'}}>
          { this.props.children }
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  layers: state.carto.layers
});

export default connect(mapStateToProps)(withCarto(DpsLayerToggle));
